import type {JSX} from 'react';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {Header} from '@/components';
import {appPaths} from '@/config/appPaths';

export default function HomePage(): JSX.Element {
  const navigate = useNavigate();
  useEffect(() => {
    // `navigate` returns `void | Promise<void>` depending on router mode, so
    // normalise before attaching a handler. The redirect is fire-and-forget:
    // a rejected navigation just leaves this placeholder page on screen.
    Promise.resolve(navigate('/' + appPaths.users, {replace: true})).catch(
      () => {},
    );
  }, [navigate]);

  return (
    <div className="my-5 mx-4 md:mx-10 overflow-x-auto overflow-y-auto max-h-screen">
      <Header title="Home" />
      <div>Welcome to the Admin Portal</div>
    </div>
  );
}
